<template>
  <component :is="dashboardComponent" :key="$store.state.national.mode" v-bind="$props" />
</template>

<script>
import Finder from './registration/Finder.vue';
import NewFinder from './registration/NewFinder.vue';

export default {
  name: 'DashboardWrapper',
  props: {
    id: String,
    name: String,
    defaultCriteria: String,
    memberId: Number,
    productId: String,
    password: String,
    entityId: String,
  },
  computed: {
    dashboardComponent() {
      const { mode } = this.$store.state.national;
      return mode === 'beta' ? NewFinder : Finder;
    },
    mode() {
      return this.$store.state.national.mode;
    }
  }
};
</script>
